<template>
  <div class="w-full p-4 sm:p-5 animate-pulse">
    <div class="mb-4 h-10 w-full sm:w-1/3 bg-gray-100 rounded-lg"></div>
    <div class="w-full overflow-hidden">
      <div class="flex border-b border-gray-100 pb-3 mb-3 space-x-6">
        <div
          v-for="col in columns"
          :key="'head-' + col"
          class="h-3 bg-gray-200 rounded flex-1"
        ></div>
      </div>
      <div
        v-for="row in rows"
        :key="'row-' + row"
        class="flex items-center border-b border-gray-50 py-3 space-x-6"
      >
        <div
          v-for="col in columns"
          :key="'cell-' + row + '-' + col"
          class="h-3 bg-gray-100 rounded flex-1"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonTable",
  props: {
    rows: {
      type: Number,
      default: 6,
    },
    columns: {
      type: Number,
      default: 6,
    },
  },
};
</script>

<style scoped></style>
